import { fetchData } from '@eliadmin/core/src/api/fetcher';
import type { LoginResponse } from '@eliadmin/core/src/api/customers/customers-types';
import type { RegisterFormSchoolValues } from '../../components/auth/register-form-school';

/** Keep the provider contact and the account login email as distinct backend fields. */
export function buildSchoolRegistrationPayload(data: RegisterFormSchoolValues) {
  const { email, ...fields } = data;
  return {
    ...fields,
    country: { id: data.country.id },
    contact_email: email,
    is_educational_agency: data.is_educational_agency ?? false,
  };
}

export function registerJobinterviewSchool({
  locale,
  ...data
}: RegisterFormSchoolValues & { locale: string }) {
  return fetchData<LoginResponse>({
    uri: '/job-portal/schools/register',
    method: 'POST',
    locale,
    body: buildSchoolRegistrationPayload(data),
  });
}
